<template>
  <transition name="animateul" enter-active-class="animated bounceInLeft" leave-active-class="animated zoomOutUp" appear>
  <li>

    <div v-if="model" >
      <span @click="toggleChildren">
        <b-icon
          icon="chevron-right"
          size="is-small"
          class="chevron-icon ulvertical linkitem"
          :custom-class="showChildren ? 'mdi-rotate-90' : ''"
          v-if="isFolder"
        />
      </span>

      <a v-if="model.tipo_ruta == 'LINK'" :href="model.ruta" target="_blank">
        <span class="menu-text menu-label has-text-weight-bold">
        {{ model.nombre }}
        </span>
      </a>
      <a v-else-if="model.tipo_ruta == 'BOLETA'" :href="compBoletasLink" target="_blank">
        <span class="menu-text menu-label has-text-weight-bold">
        {{ model.nombre }}
        </span>
      </a>
      <a v-else class="cursor-default " @click="descargar(model.ruta,model.id,model.tipo_ruta)" target="_self">
        <span class="menu-text menu-label has-text-weight-bold"> {{ model.nombre }}</span>

      </a>

      <ul
        :class="{'is-active': showChildren}"
        style="margin-bottom: 0.3rem;"
        v-if="isFolder">
        <sidebar-item :key="model.id"
          v-for="model in model.hijos"  :model="model">
        </sidebar-item>
      </ul>
    </div>
  </li>
  </transition>
</template>

<script>
  import {mapGetters} from 'vuex'
    export default {
        props: ['model'],
        name: "SidebarItem",

      computed:{
        ...mapGetters({'auth':'security/getAuth'}),
        compBoletasLink: function(){
          this.dataurl=this.model.ruta + "&name="+this.auth.user.preferred_username

          return this.dataurl
        },
        isFolder: function () { return this.model.hijos && this.model.hijos.length }

      },
      data: function(){
        return {
          open: false,
          dataurl:'',
          showChildren: false,

        }
      },
      components: {

      },
      methods:{

        toggleChildren() {
          this.showChildren = !this.showChildren;
          console.log(" show "+this.showChildren);
        },
        descargar(ruta,id,tipo) {

          if (ruta){
            if(tipo){
              if(tipo=='ruta'){
                this.$router.push({name: ruta})
              }else if(tipo=='FILE'){

                this.$router.push({name: 'user.intranet', params:{code:id}})

                // --------------COGIO REDIRECT CON PARAEMETRO

                this.$http.post('api/logIntranet', {codigoArchivo: id})
                  .then((response) => {
                    console.log("Registro correcto de log!!");
                    //window.open(ruta)
                    this.vertical = response.data;
                  });
              }else if(tipo=='CUMPLE'){

                this.$router.push({name: 'user.intranet', params:{code:id}})

             }else if(tipo == 'LINK'){
                ruta
              }else if(tipo=='ZIP'){

                this.$router.push({name: 'user.intranet', params:{code:1010}})

                window.open(ruta)
              }else{
                toggleChildren();
              }
            }
            console.log(" hay data");
        }else{

            this.toggleChildren();
          }

        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/SidebarItem.vue